// track/components/VendorsView.tsx
import React from 'react';
import { Plus } from 'lucide-react';
import { Vendor } from '../types';

interface VendorsViewProps {
  vendors: Vendor[];
  canWrite: boolean;
  onAddVendor: () => void;
}

const VendorsView: React.FC<VendorsViewProps> = ({ vendors, canWrite, onAddVendor }) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Vendors</h2>
        {canWrite && (
          <button
            onClick={onAddVendor}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Vendor
          </button>
        )}
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Merchant Mappings</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {vendors.map(vendor => (
              <tr key={vendor.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{vendor.name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vendor.email || '-'}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{vendor.phone || '-'}</td>
                <td className="px-6 py-4 text-sm text-gray-900">
                  {vendor.merchantMappings?.length ? (
                    <div className="flex flex-wrap gap-1">
                      {vendor.merchantMappings.map((mapping, index) => (
                        <span key={index} className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-800">
                          {mapping}
                        </span>
                      ))}
                    </div>
                  ) : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {vendors.length === 0 && (
          <div className="text-center py-8">
            <p className="text-gray-500">No vendors found. {canWrite ? 'Add your first vendor to get started.' : ''}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorsView;